import React from "react";
import PropTypes from "prop-types";
import { Button, Spinner } from "reactstrap";

import { blue50 } from "calls/styles/Comments.module.scss";
import NetworkStatus from "calls/components/NetworkStatus";

const spinner = (
  <div className="d-flex flex-column align-items-center">
    <Spinner color="secondary"/>
  </div>
);

const LoadMoreThreads = ({ networkStatus, hasNextPage, loadMore }) => {
  const loadMoreThreadsButton = () => {
    if (hasNextPage) {
      return (
        <div className="d-flex flex-column align-items-center mb-4">
          <Button
            data-test-id="load-more-threads-button"
            color="primary"
            style={{ backgroundColor: blue50, color: "white", border: 0 }}
            onClick={loadMore}
          >
            Load more threads
          </Button>
        </div>
      );
    }
  };

  return networkStatus === NetworkStatus.fetchMore ? spinner : (loadMoreThreadsButton() || null);
};

LoadMoreThreads.propTypes = {
  networkStatus: PropTypes.number,
  hasNextPage: PropTypes.bool,
  loadMore: PropTypes.func.isRequired
};

export default LoadMoreThreads;
